export const ORG_APPROVAL_SAMPLE = {
  firstName: 'Sarah',
  configurationUrl: 'https://gotrustjet.com/dashboard/settings',
  bankingUrl: 'https://gotrustjet.com/dashboard/banking',
};
